import { CampaignType } from 'types/campaign'

export const CONFIRM_CAMPAIGN = 'CONFIRM_CAMPAIGN'
export const confirmCampaignAction = (campaign: CampaignType) => {
  return {
    type: 'CONFIRM_CAMPAIGN',
    payload: campaign,
  }
}

export const FETCH_CAMPAIGNS = 'FETCH_CAMPAIGNS'
export const fetchCampaignsAction = (campaigns: CampaignType[]) => {
  return {
    type: 'FETCH_CAMPAIGNS',
    payload: campaigns,
  }
}

export const INIT_CAMPAIGNS = 'INIT_CAMPAIGNS'
export const initCampaignsAction = () => {
  return {
    type: 'INIT_CAMPAIGNS',
    payload: null,
  }
}
